import script from "./UndanewsCDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UndanewsCDialog.vue?vue&type=script&setup=true&lang=js"

import "./UndanewsCDialog.vue?vue&type=style&index=0&id=a034e040&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a034e040"]])

export default __exports__